/* Autoescuela Centro - selector de carnet (pestanas accesibles, sin dependencias) */
(function () {
function initSelector(root) {
if (root.dataset.centroReady === 'true') return;
root.dataset.centroReady = 'true';

var tablist = root.querySelector('[role="tablist"]');
if (!tablist) return;
var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
if (!tabs.length) return;

function panelFor(tab) {
var id = tab.getAttribute('aria-controls');
if (!id) return null;
return root.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id));
}

function select(index, focus) {
tabs.forEach(function (tab, i) {
var active = i === index;
tab.setAttribute('aria-selected', active ? 'true' : 'false');
tab.setAttribute('tabindex', active ? '0' : '-1');
tab.classList.toggle('is-active', active);
var panel = panelFor(tab);
if (panel) panel.hidden = !active;
});
if (focus && tabs[index]) tabs[index].focus();
}

root.centroSelect = select;

tabs.forEach(function (tab, i) {
tab.addEventListener('click', function () { select(i, false); });
tab.addEventListener('keydown', function (event) {
var last = tabs.length - 1;
var next = null;
switch (event.key) {
case 'ArrowDown':
case 'ArrowRight': next = i === last ? 0 : i + 1; break;
case 'ArrowUp':
case 'ArrowLeft': next = i === 0 ? last : i - 1; break;
case 'Home': next = 0; break;
case 'End': next = last; break;
default: return;
}
event.preventDefault();
select(next, true);
});
});
}

function initAll() {
document.querySelectorAll('[data-centro-selector]').forEach(initSelector);
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initAll);
} else {
initAll();
}

document.addEventListener('shopify:section:load', function (event) {
var root = event.target.querySelector('[data-centro-selector]');
if (root) initSelector(root);
});
})();
